import axios from '../../../config/axiosConfig';
import { ErrorResponse } from '../../../shared';
import gaEvents from '../../../shared/analyticsEvents';
import { ExitTestResponse } from './TestResultsStudent.interfaces';

export const fetchAdminAndStudent = async(testTicketID: string, fromQuiz: boolean, fromDeepLink: boolean):
  Promise<ExitTestResponse|ErrorResponse> => {
  const request = {
    TestTicketID: testTicketID,
    FromQuiz: fromQuiz.toString(),
    FromDeepLink: fromDeepLink.toString()
  };
  const response = await axios.post<ExitTestResponse>('api/testLaunch/ExitDigitalTest',
    request,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(res => res.data)
    .then((results): ExitTestResponse => ({
      __typename: 'ExitTestResponse',
      administration: results.administration,
      studentTestTicket: results.studentTestTicket,
      testTakerType: results.testTakerType,
      reports: results.reports,
      showResults: results.showResults

    }))
    .catch((errMsg: string):ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};

export const printHandler = (): void => {
  const printEl = document.getElementById('student-item-detail-section');
  const printAnchor = document.getElementById('report-print-anchor');
  if (printEl && printAnchor) {
    printEl.style.visibility = 'hidden';
    document.body.appendChild(printEl);
    window.print(); // thread blocking
    printEl.style.visibility = 'visible';
    document.body.removeChild(printEl);
    printAnchor.appendChild(printEl);
    gaEvents.onGA4PrintStudentReport();
  }
};